<template>
	<div class="main">
		<popupLayout>
			<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="closePopup">×</button>
			<div class="bootbox-body">
				<header class="form-group mb-lg">
					<label class="col-md-12" style="font-size: 2em;">晤談記錄</label>
				</header>
				<div class="row form-group mb-lg">
					<div class="col-md-12 text-right">
						<button type="button" class="btn btn-danger" @click="isAdd=true;">新增晤談記錄</button>
					</div>
				</div>
				<div class="row form-group mb-lg">
					<div class="col-md-12">
						<table class="table table-no-more table-bordered table-striped mb-none">
							<thead>
								<tr>
									<th class="text-center" style="width:20%;"></th>
									<th class="text-center" style="width:50%;">晤談記錄內容</th>
									<th class="text-center" style="width:30%;">晤談記錄時間</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(x, i) in interviewRecords" :key="i">
									<td>
										<a href="javascript:;" class="btn btn-link text-danger" @click="deleteInterview(x.sno)">刪除</a>
									</td>
									<td>{{x.interviewContent}}</td>
									<td>{{customFormatter(x.interviewDate, "YYYY/MM/DD HH:mm:ss")}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</popupLayout>
		<popupLayout v-if="isAdd">
			<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="isAdd=false;">×</button>
			<div class="bootbox-body">
				<div class="row form-group mb-lg">
					<label class="col-md-12">晤談記錄</label>
					<div class="col-md-12">
						<textarea class="form-control" name="tutorRecord" v-model="interviewRecord.interviewContent" rows="5" maxlength="400" v-validate="'required|max:400'"></textarea>
						<span class="text-danger" v-show="errors.has('tutorRecord')">{{ errors.first('tutorRecord') }}</span>
					</div>
				</div>
				<div class="row">
					<div class="col-md-offset-4 col-md-4">
						<div class=" col-md-offset-3 col-md-6">
							<a class="btn btn-danger btn-block" @click="saveInterview">送出</a>
						</div>
					</div>
				</div>
			</div>
		</popupLayout>
	</div>
	
</template>
<script>
import popupLayout from '@/components/popup/popupLayout';
export default {
	components:{
		popupLayout
	},
	props:["smtr","account"],
	data(){
		return {
			interviewRecords:[],
			interviewRecord:{
				interviewContent:"",
			},
			isAdd:false
		}
	},
	mounted(){
		this.PopupInit();
	},
	methods:{
		PopupInit(){
			const ApiFunc = async () => {
				return await this.$axios.post(`/api/Violate/interview/${this.account}`)
			}
			Promise.resolve(ApiFunc()).then(resp => {
				this.interviewRecords = resp.data;
			});
		},
		closePopup() {
			this.$parent.showInterviewPopupControl(false);
		},
		saveInterview(){
			let _this = this;
			this.$validator.validateAll().then(result => {
				if(result){
					const api = "/api/Violate/saveInterview";
					this.$axios.post(api, JSON.stringify({
						account:this.account,
						interviewContent:this.interviewRecord.interviewContent
					})).then(resp => {
						bootbox.alert(resp.data.msg, function(){
							if(resp.data.status == "success"){
								_this.isAdd = false;
								_this.PopupInit();
								_this.interviewRecord.interviewContent
							}
						});
					});
				}else{
					bootbox.alert("請確認必填欄位是否有填寫");
				}
			});
		},
        deleteInterview(sno){
            let _this = this;
            const ApiFunc = async () => {
				return await this.$axios.delete(`/api/Violate/interview/${sno}`)
			}
            bootbox.confirm("是否刪除此筆記錄", result => {
                if(result){
                    Promise.resolve(ApiFunc()).then(resp => {
                        bootbox.alert(resp.data.msg, () => {
                            if(resp.data.status == "success"){
                                _this.PopupInit();
                            }
                        })
			        });
                }
            });
			
        }
	}
}
</script>